import React from 'react'
import Login from '../components/account/Login/Login'

const LoginPage = () => {
  return (
    <>
    <Login />
    </>
  )
}

export default LoginPage